function EmptyComponent() {
  return <div>No payouts to display</div>;
}

export default EmptyComponent;
